/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */
import { normalize, Schema, arrayOf } from 'normalizr';

import _get from 'lodash/get';
import _map from 'lodash/map';
import _orderBy from 'lodash/orderBy';

import moment from 'moment';

export const INIT_PROGRAM_GUIDE = 'init-program-guide';
export const FETCH_PROGRAM_GUIDE = 'fetch-program-guide';
export const APPEND_PROGRAM_GUIDE = 'append-program-guide';
export const GET_PROGRAM_GUIDE_FOR_CHANNEL = 'append-program-guide-for-channel-by-id';
export const CLEAR_OLD_SCHEDULE = 'clear-events-and-schedule-stores';

import { prepareSchedule } from '../../utils';

const event = new Schema('event');
const schedule = new Schema('schedule');

schedule.define({
  schedule: arrayOf(event)
});

export const GetAllChannelsSortedByFavAndLcn = (options) => {

  let request = lh.channel.getAssets({
    select: [
      lh.models.channelAsset.schema.id,
      lh.models.channelAsset.schema.title,
      lh.models.channelAsset.schema.er_lcn,
      lh.models.channelAsset.schema.resources,
      lh.models.channelAsset.schema.is_catchup_available,
      lh.models.channelAsset.schema.has_adult_content,
      lh.models.channelAsset.schema.offers,
      lh.models.channelAsset.schema.package_id,
      lh.models.channelAsset.schema.genres
    ],
    filters: [
      lh.models.channelAsset.accessor.is_epg_available.true(),
      lh.models.channelAsset.accessor.categories.eq(options.category)
    ],
    sort: 'er_lcn'
  });

  return {
    type: INIT_PROGRAM_GUIDE,
    meta: {
      limit: options.limit
    },
    payload: request.then((channels) => {

      if (!channels.length) return [];

      return _orderBy(channels, ['is_favorite', 'er_lcn'], ['desc', 'asc']);
    })
  };
};

/**
 *
 * @param channels
 * @param options
 * @returns {{type: string, payload: Promise.<Array.<lh.models.epgEvent.Model>>}}
 */
export const FetchProgramGuide = (channels, options) => {

  return {
    type: FETCH_PROGRAM_GUIDE,
    meta: {
      channels: _map(channels, 'id')
    },
    payload: lh.epg
      .getSchedule({
        channelIds: _map(channels, 'id'),
        startTime: options.start,
        endTime: options.end,
        select: ['channel_id', 'description', 'duration', 'id', 'is_catchup_available', 'is_startover_available', 'program_id', 'start', 'title', 'program', 'catchup_start_correction', 'drm_verimatrix_id']
      })
      .then((collection) => {

        let normalizedSchedule = normalize(collection.map(function (item) {
          item.schedule = prepareSchedule(item.schedule, {
            start: options.start,
            end: options.end,
            channel_id: item.id,
          });

          return item;
        }), arrayOf(schedule));

        return normalizedSchedule;
      })
  };
};

export const AppendProgramGuide = (channels, options) => {

  return {
    type: APPEND_PROGRAM_GUIDE,
    meta: {
      channels: _map(channels, 'id')
    },
    payload: lh.epg
      .getSchedule({
        channelIds: _map(channels, 'id'),
        startTime: options.start,
        endTime: options.end,
        select: ['channel_id', 'description', 'duration', 'id', 'is_catchup_available', 'is_startover_available', 'program_id', 'start', 'title', 'program', 'catchup_start_correction', 'drm_verimatrix_id']
      })
      .then((collection) => {

        let normalizedSchedule = normalize(collection.map(function (item) {
          item.schedule = prepareSchedule(item.schedule, {
            start: options.start,
            end: options.end,
            channel_id: item.id,
          });

          return item;
        }), arrayOf(schedule));

        return normalizedSchedule;
      })
  };
};

/**
 *
 * @param channel_id
 * @param options
 * @returns {{type: string, payload: Promise.<Array.<lh.models.epgEvent.Model>>}}
 */
export const GetProgramGuideById = (channel_id, options, location) => {

  return {
    type: GET_PROGRAM_GUIDE_FOR_CHANNEL,
    meta: {
      key: channel_id,
      location: location
    },
    payload: lh.epg
      .getSchedule({
        channelIds: [channel_id],
        startTime: options.start,
        endTime: options.end,
        select: ['channel_id', 'description', 'duration', 'id', 'is_catchup_available', 'is_startover_available', 'program_id', 'start', 'title', 'program', 'catchup_start_correction', 'drm_verimatrix_id']
      })
      .then((collection) => {
        options.channel = {id: channel_id};

        let normalizedSchedule = normalize(collection.map(function (item) {

          item.schedule = prepareSchedule(item.schedule, {
            start: options.start,
            end: options.end,
            channel_id: item.id,
          });

          return item;
        }), arrayOf(schedule));

        return normalizedSchedule;
      })
  };
};


export const ClearScheduleStore = (schedule, location) => {

  return {
    type: CLEAR_OLD_SCHEDULE,
    meta: {
      location: location
    },
    payload: schedule
  }
};



// WEBPACK FOOTER //
// ./src/actions/schedule/actions-schedule.js